import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const registerUser = createAsyncThunk(
    "auth/register",
    async (formData, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}auth/register`,
          formData,
          {
            withCredentials: true,
          }
        );
        console.log(response.data,'response,');
        
        return response.data;
      } catch (err) {
        // Handle validation errors from the server
        if (err.response && err.response.data) {
          return rejectWithValue(err.response.data);
        }
        return rejectWithValue("Registration failed");
      }
    }
  );
  export const loginUser = createAsyncThunk(
    "auth/login",
    async (formData, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}auth/login`,
          formData,
          {
            withCredentials: true,
          }
        );
        console.log(response.data,'response,');
        
        return response.data;
      } catch (err) {
        // Handle validation errors from the server
        if (err.response && err.response.data) {
          return rejectWithValue(err.response.data);
        }
        return rejectWithValue("login failed");
      }
    }
  );

